import React, { useEffect, useState } from "react";
import { GridColDef, GridRenderCellParams } from "@mui/x-data-grid";
import { Chip, Stack } from "@mui/material";
import ActionsCell from "./actionsCell";
import { enqueueSnackbar } from "notistack";
import {
  // createQuestion,
  deleteQuestion,
  updateQuestion,
} from "../services/programService";
import EmailAvatar from "./EmailAvatar";
import { DynamicTableListTemplate } from "./shared/DynamicTableListTemplate";
import { useHandleError } from "../hooks/useHandleError";
import { Module, ModuleQuestion } from "../types/ProgramModel";
// import ModuleQuestionForm from "./forms/ModuleQuestionForm";
import DbService from "../services/DbService";

interface ModuleQuestionListProps {
  module: Module;
}

const ModuleQuestionList: React.FC<ModuleQuestionListProps> = ({ module }) => {
  const handleError = useHandleError();

  const [loading, setLoading] = React.useState(false);

  const [selectedQuestion, setSelectedQuestion] = useState<
    ModuleQuestion | undefined
  >(undefined);
  const [questionToDelete, setQuestionToDelete] =
    useState<ModuleQuestion | null>(null);

  const [hasQuestionsChanged, setHasQuestionsChanged] =
    useState<boolean>(false);

  const hasFetchedRef = React.useRef(false);

  const columns: GridColDef[] = [
    {
      field: "isActive",
      headerName: "Status",
      width: 90,
      renderCell: (params) => {
        const color = params.value === true ? "success" : "default";
        const text = params.value === true ? "ACTIVE" : "DISABLED";
        return (
          <Chip
            style={{ fontSize: ".7rem" }}
            label={text}
            size="small"
            color={color}
          />
        );
      },
    },
    { field: "image", headerName: "Image" },
    { field: "type", headerName: "Type" },
    { field: "question", headerName: "Question" },
    { field: "answer", headerName: "Answer" },
    {
      field: "updatedAt",
      headerName: "Updated At",
      width: 130,
      renderCell: (params: GridRenderCellParams) => {
        if (!params.value) {
          return;
        }
        const updatedBy = params.row["updatedBy"];
        const date = new Date(params.value);
        // Format the date using the user's local computer locale
        const formattedDate = date.toLocaleDateString("en-AU");

        return (
          <div
            style={{
              display: "flex",
              gap: ".25rem",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
            }}
          >
            <span>{formattedDate}</span>
            <EmailAvatar email={updatedBy}></EmailAvatar>
          </div>
        );
      },
    },
    {
      field: "actions",
      headerName: "",
      width: 60,
      sortable: false,
      filterable: false,
      renderCell: (params: GridRenderCellParams) => {
        const row: ModuleQuestion = params.row as ModuleQuestion;

        return (
          <ActionsCell
            onEdit={() => handleEditQuestion(row)}
            onDelete={() => handleDeleteQuestion(row)}
          />
        );
      },
    },
  ];

  // useEffect(() => {
  //   const fetchQuestions = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await DbService.getQuestions(module.moduleId);
  //       setQuestions(response.data);
  //     } catch (error) {
  //       handleError(error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   if (!hasFetchedRef.current) {
  //     fetchQuestions();
  //     hasFetchedRef.current = true;
  //   }
  // }, [handleError, setQuestions]);

  const handleCloseDialog = () => {
    setSelectedQuestion(undefined);
    if (hasQuestionsChanged) {
      refreshList();
    }
  };

  // const handleCreateQuestion = async (questionData: ModuleQuestion) => {
  //   if (questionData.id) {
  //     handleUpdateQuestion(questionData);
  //   } else {
  //     try {
  //       const response = await createQuestion({
  //         ...questionData,
  //         module: module.moduleId,
  //       });

  //       enqueueSnackbar(response.message, {
  //         variant: "success",
  //       });

  //       setSelectedQuestion(response.data);
  //       setHasQuestionsChanged(true);
  //     } catch (error) {
  //       handleError(error);
  //     }
  //   }
  // };

  const handleUpdateQuestion = async (updatedQuestionData: ModuleQuestion) => {
    if (!updatedQuestionData.id) {
      return;
    }
    try {
      const response = await updateQuestion(
        module.moduleId,
        updatedQuestionData.id,
        updatedQuestionData
      );

      setSelectedQuestion(updatedQuestionData);

      enqueueSnackbar(response.message, {
        variant: "success",
      });
      setHasQuestionsChanged(true);
    } catch (error) {
      handleError(error);
    }
  };

  const handleEditQuestion = (row: ModuleQuestion) => {
    setSelectedQuestion(row);
  };

  const handleDeleteQuestion = async (row: ModuleQuestion) => {
    if (!row?.id) {
      enqueueSnackbar(`Id is missing from this question`, {
        variant: "error",
      });
      return;
    }
    setQuestionToDelete(row);
  };

  const handleDeleteQuestionConfirm = async (
    row: ModuleQuestion | null | undefined
  ) => {
    if (row?.id) {
      try {
        const response = await deleteQuestion(row.id);
        enqueueSnackbar(response.message, {
          variant: "success",
        });
        refreshList();
      } catch (error) {
        handleError(error);
      } finally {
        setQuestionToDelete(null);
      }
    }

    setQuestionToDelete(null);
  };

  const refreshList = async () => {
    setLoading(true);
    // try {
    //   await refreshQuestionAndPrincipalList();
    // } catch (err: any) {
    //   handleError(err);
    // } finally {
    //   setLoading(false);
    // }
  };

  return (
    <DynamicTableListTemplate<ModuleQuestion>
      columns={columns}
      data={module?.questions || []}
      loading={loading}
      selectedRow={selectedQuestion}
      // FormComponent={
      //   <ModuleQuestionForm
      //     selectedQuestion={selectedQuestion}
      //     onSubmit={handleCreateQuestion}
      //   />
      // }
      entityLabel="Question"
      dialogTitle="Question Entry Form"
      onClearSelectedRow={handleCloseDialog}
      onConfirmDelete={handleDeleteQuestionConfirm}
      entityToDelete={questionToDelete}
    />
  );
};
export default ModuleQuestionList;
